var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tips-box"},[_c('p',[_vm._v("1、 国内短信由签名+正文组成，签名符号为【】（注：全角），发送短信内容时必须带签名;")]),_vm._v(" "),_c('p',[_vm._v("2、 短信签名和模板提交后，预计2小时完成审核。审核时间：周一至周日9:00-23:00(法定节假日正常服务)。")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0da27d95","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/message/tips.vue
// module id = null
// module chunks = 